<template>
  <div>
    <v-row class="mt-3">
      <v-col cols="12" sm="4" lg="3">
        <v-select
          :items="monthOptions"
          item-value="value"
          item-text="text"
          label="Month"
          v-model="selectedMonth"
          :clearable="false"
          outlined
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-tabs v-model="tab">
          <v-tab :key="TABLE">
            <v-icon>table_chart</v-icon>
          </v-tab>
          <v-tab :key="CHART">
            <v-icon>bar_chart</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="TABLE">
            <v-container fluid class="pa-0 ma-0">
              <v-row justify="end" class="mb-2">
                <v-col cols="auto">
                  <ButtonCustomIcon
                    icon="cloud_download"
                    color="primary"
                    text="Excel"
                    :disabled="tableRows.length === 0"
                    @click="handleExportToExcel"
                  />
                </v-col>
              </v-row>
              <v-data-table
                dense
                :headers="headers"
                :items="tableRows"
              >
                <template v-slot:item.overheadPercent="{ item }">
                  {{ item.overheadPercent | percent }}
                </template>
                <template v-slot:item.monthlyPayAmount="{ item }">
                  {{ item.monthlyPayAmount | currency }}
                </template>
                <template v-slot:item.commission="{ item }">
                  {{ item.commission | currency }}
                </template>
                <template v-slot:item.totalPayAmount="{ item }">
                  {{ item.totalPayAmount | currency }}
                </template>
                <template v-slot:item.totalIndividualGP="{ item }">
                  {{ item.totalIndividualGP | currency }}
                </template>
                <template v-slot:item.ler="{ item }">
                  {{ parseFloat(item.ler).toFixed(2) }}
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="CHART">
            <bar-chart
              :data="lineChartData"
              :round="2"
              thousands=","
              loading="Loading..."
              :colors="['#0066ff']"
            ></bar-chart>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ButtonCustomIcon } from '@/components/buttons'
import { formatCurrency, formatPercent } from '@/lib/display'
import excel from '@/lib/export/excel'

export default {
  components: {
    ButtonCustomIcon
  },
  props: [
    'laborEfficiencyRatioMonths'
  ],
  data () {
    return {
      selectedMonth: new Date().getMonth() - 1,
      headers: [
        { text: 'Employee', value: 'employeeName', width: '200px' },
        { text: 'Overhead', value: 'overheadPercent', align: 'right', width: '120px' },
        { text: 'Monthly Pay Amount', value: 'monthlyPayAmount', align: 'right', width: '180px' },
        { text: 'Commission', value: 'commission', align: 'right', width: '130px' },
        { text: 'Total Pay Amount', value: 'totalPayAmount', align: 'right', width: '160px' },
        { text: 'GP Month', value: 'totalIndividualGP', align: 'right', width: '130px' },
        { text: 'LER', value: 'ler', align: 'right', width: '100px' }
      ],
      tab: 0,
      TABLE: 0,
      CHART: 1
    }
  },
  computed: {
    monthOptions () {
      let options = []
      let value = 0
      if (this.laborEfficiencyRatioMonths) {
        for (const item of this.laborEfficiencyRatioMonths) {
          options.push({
            value: value++,
            text: item.period
          })
        }
      }
      return options
    },
    lineChartData () {
      let data = []
      if (this.laborEfficiencyRatioMonths) {
        let lerSelectedMonth = this.laborEfficiencyRatioMonths[this.selectedMonth]
        let lerItems = lerSelectedMonth.laborEfficiencyRatioItems
        for (const item of lerItems) {
          data.push([item.employeeName, item.ler])
        }
      }
      return data
    },
    tableRows () {
      let data = []
      if (this.laborEfficiencyRatioMonths) {
        let lerSelectedMonth = this.laborEfficiencyRatioMonths[this.selectedMonth]
        let lerItems = lerSelectedMonth.laborEfficiencyRatioItems
        for (const item of lerItems) {
          data.push(item)
        }
      }
      return data
    }
  },
  methods: {
    handleExportToExcel () {
      if (this.tableRows.length === 0) {
        return
      }

      const data = this.tableRows.map(item => ({
        employeeName: item.employeeName,
        overheadPercent: formatPercent(item.overheadPercent),
        monthlyPayAmount: formatCurrency(item.monthlyPayAmount),
        commission: formatCurrency(item.commission),
        totalPayAmount: formatCurrency(item.totalPayAmount),
        totalIndividualGP: formatCurrency(item.totalIndividualGP),
        ler: parseFloat(item.ler).toFixed(2)
      }))

      excel.exportArray2Excel({
        title: this.headers.map(header => header.text),
        key: this.headers.map(header => header.value),
        data,
        autoWidthFlag: true,
        filename: 'Labor Efficiency Ratio'
      })
    }
  }
}
</script>
